export const defaultImage = 'https://picsum.photos/200/300?random=1'